import e from "../../utils/classNames.js";
import { getOrCreatePortalRoot as t } from "../../utils/portalRoot.js";
import n from "react";
import { AnimatePresence as r, motion as i } from "motion/react";
import { Fragment as a, jsx as o, jsxs as s } from "react/jsx-runtime";
import c from "react-dom";
//#region src/components/applicationHeader/MobileHeaderModal.tsx
var l = -1e3, u = (u) => {
	let { show: d = !1, showClose: f = !0, modalClassName: p, className: m, onClose: h = () => {}, children: g } = u, _ = e("MobileHeaderModal", "position-fixed left-0 right-0 bottom-0", "z-index-max", m), v = e("display-flex flex-column justify-content-center", "margin-15", "text-center", "rounded", "bg-white", "shadow-hard", "overflow-auto", p), y = t(), b = window.innerHeight - 30, x = l - window.innerHeight;
	return /* @__PURE__ */ o(a, { children: c.createPortal(/* @__PURE__ */ s(n.Fragment, { children: [/* @__PURE__ */ o(r, { children: d && /* @__PURE__ */ s(i.div, {
		className: _,
		initial: {
			opacity: 0,
			top: x
		},
		animate: {
			opacity: 1,
			y: 0,
			top: 0
		},
		exit: {
			opacity: 0,
			transition: { duration: .3 },
			top: x
		},
		children: [/* @__PURE__ */ o("div", {
			className: v,
			style: { height: `${b}px` },
			children: g
		}), f && /* @__PURE__ */ o("div", {
			className: "position-absolute top-15 right-15 margin-top-15 margin-right-15 text-size-20 text-color-dark",
			onClick: h,
			children: /* @__PURE__ */ o("span", { className: "uikit-icon icon-remove" })
		})]
	}) }), /* @__PURE__ */ o(r, { children: d && /* @__PURE__ */ o(i.div, {
		className: "bottom-sheet-backdrop",
		initial: { opacity: 0 },
		animate: { opacity: .5 },
		exit: { opacity: 0 }
	}) })] }), y) });
};
//#endregion
export { u as default };

//# sourceMappingURL=MobileHeaderModal.js.map